// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Dab7D","containerFixed":"styles_containerFixed__NLR9L","wrapper":"styles_wrapper__jtCGM","wrapperCompact":"styles_wrapperCompact__weo4_"};